/*  ========================================================================
    # Components - Sections - What Is It
    ========================================================================  */

// Dependencies
import React, { useRef } from 'react';

// Assets
import Modal from '../components/Modal';
import Pill from '../components/Pill';
import Button from '../components/Button';

const WhatIsIt = () => {
  const modalRef = useRef(null);

  return (
    <section id='what-is-it' className='s-what-is-it'>
      <div className='container'>
        <Pill
          text='Was ist der Förderpreis?'
          alt='Was ist der Förderpreis?'
          image='/wp-content/themes/raiffeisen-foerderpreis/dist/images/misc/foerderpreis-bulb.jpg'
          withGradient
          onClick={() => modalRef.current?.open()}
        />
        <Modal ref={modalRef}>
          <Pill
            alt='Was ist der Förderpreis?'
            image='/wp-content/themes/raiffeisen-foerderpreis/dist/images/misc/foerderpreis-bulb.jpg'
          />
          <div className='wysiwyg-block'>
            <h1 className='s-what-is-it__modal-headline u-text-blue'>Was ist der Förderpreis?</h1>
            <h3 className='u-text-purple'>Deine Region. Dein Projekt. Deine Zukunft.</h3>
            <p>
              Welche Erlebnisse kann eine Region bereithalten, welchen Abenteuern Schauplatz bieten
              und welche Geschichten erzählen? Deine Ideen entscheiden. Wofür schlägt Dein Herz? Wir
              möchten Dich und Deine Idee unterstützen.
            </p>
            <p>
              Du hast die Möglichkeit im Zeitraum
              {' '}
              <strong>vom 31. März 2025 bis 30. Juni 2025</strong>
              ,
              Deine Ideen zur Gestaltung Deiner Region einzureichen. Die besten zehn Ideen werden
              der Jury am 14. August durch die Teilnehmer virtuell vorgestellt. Die Jury besteht aus den
              Vorständen der Raiffeisen-Gesellschaft sowie einem Vertreter der Stiftung des Förderkreises
              der Genossenschaftsmitglieder. Gehörst Du zu den drei Gewinnern, bist
              Du am 17. September bei der Preisverleihung in Frankfurt am Main dabei. Die drei Gewinner
              erwartet insgesamt ein Preisgeld von 10.000 € zur Umsetzung der Ideen.
            </p>
            <h3 className='u-text-purple'>Worauf kommt es an?</h3>
            <p>
              Achte darauf, dass Deine Idee gut durchdacht und tatsächlich umsetzbar ist. Das heißt,
              sie sollte kein Vermögen kosten, zukunftsfähig sein und vor allem viele Menschen
              ansprechen. Wenn Deine Idee diese Kriterien erfüllt, bist Du dem Preisgeld schon etwas
              näher.
            </p>
            <Button
              label='Hast Du eine eigene Idee? Jetzt einreichen!'
              to='/mitmachen'
              onClick={() => modalRef.current?.close()}
            />
          </div>
        </Modal>
      </div>
    </section>
  );
};

export default WhatIsIt;
